import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Pizza is scary",
  "description": "",
  "published": "2007-02-26T00:00:00.000Z",
  "redirect_from": ["/blog/pizza-is-scary/swizec/283"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`And this is how pizza can leave you scarred and scared for life!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      